import { BucketName } from '../s3';

type Params = {
  bucketName: BucketName;
  imageName: string | null | undefined;
  subPath?: string; // publication.id и т.п.
};

const FALLBACK = '/broken-image.svg';

function trimSlashes(s: string) {
  return s.replace(/^\/+|\/+$/g, '');
}

export default function cdnImageUrl({ bucketName, imageName, subPath }: Params): string {
  const name = (imageName ?? '').trim();
  if (!name) return FALLBACK;

  const isProd = process.env.NODE_ENV === 'production';

  // В проде — CDN (нужен для ?width/&crop), в dev — origin
  const CDN = {
    'pets-sale-bucket': 'https://images-20f98.kxcdn.com',
    'pet-avatars': 'https://petavatars-20f98.kxcdn.com',
    'dogs-blog-bucket': 'https://dogsblog-20f98.kxcdn.com'
  } as const;

  const ORIGIN = {
    'pets-sale-bucket': 'https://pets-sale-bucket.storage-132.s3hoster.by',
    'pet-avatars': 'https://pet-avatars.storage-132.s3hoster.by',
    'dogs-blog-bucket': 'https://dogs-blog-bucket.storage-132.s3hoster.by'
  } as const;

  const base = (isProd ? CDN[bucketName] : ORIGIN[bucketName]).replace(/\/+$/, '');
  const sub = subPath ? trimSlashes(subPath) : '';
  const key = encodeURIComponent(name);

  // Избегаем двойных слешей
  return sub ? `${base}/${sub}/${key}` : `${base}/${key}`;
}
